<div class="modal-content">
  <div class="modal-header p-3 justify-content-center">
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="nc-icon nc-simple-remove"></i>
    </button>
    <h5 class="title title-up">{{ cadastro.nR_BPM_BEM_PATRIMONIAL }}</h5>
  </div>
  <div class="modal-body">
      <div class="row">
          <div class="card card-plain p-0">
            <div class="card-header">
             
            <table class="table">
              <thead>
                <tr>
                  <th>Autor da Evidencia</th>
                  <th>Descrição da Evidencia</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of dataArray">
                  <td>
                  {{ item.dS_AUTOR_EVIDENCIA }}
                  </td>
                  <td>
                  {{ item.dS_BPM_TEXTO_EVIDENCIA }}
                  </td>
                </tr>
                <br/> 
              </tbody>
            </table>
            <span>
              Anexe o motivo da inconsistência do movimento.
          </span>
          </div>
              <div class="card-body">
                  <form [formGroup]="form">
                      <div class="row justify-content-center">
                      
                          <div class="col-md-6 p-3">
                              <input #file 
                              type="file" 
                              enctype="multipart/form-data" 
                              (change)="onChange(file.files)">  
                          </div>
                          <div class="col-md-4">
                              <div class="form-group">
                                  <label for="nome">Registro da evidencia</label>
                                  <textarea type="text" class="form-control" placeholder="Registro da evidencia"
                                      formControlName="dS_BPM_TEXTO_EVIDENCIA"
                                      [ngClass]="{
                                        'has-danger':
                                          form.controls.dS_BPM_TEXTO_EVIDENCIA.errors?.required &&
                                          form.controls.dS_BPM_TEXTO_EVIDENCIA.touched
                                      }"required></textarea>
                              </div>
                          </div>
                          <div>
                             
                          </div>
                      </div>
                      <div class="col-md-4 mx-auto w-100 text-center">
                        <button type="submit" class="btn btn-dark"
                        (click)="cadastrarEvidenciaAvulsa()">Cadastrar registro</button>
                      </div>
                  </form>

                  

              </div>
          </div>
          <div id="accordion">
            <div class="card">
              <div class="card-header text-center" id="headingOne">
                <h5 class="mb-0">
                  <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    <strong>Alterar Cautela e saná-la</strong>
                  </button>
                </h5>
              </div>
              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body">
                <div class="col-md-12">
                  <div class="card-body">
                    <form [formGroup]="formCautela">
                      <div class="row">
                        <div class="col-md-2">
                          <label for="matricula_origem">Cautela</label>
                          <div class="form-group">
                            <input type="text" readonly class="form-control" placeholder="Matricula de origem"
                              id="matricula_origem" formControlName="cD_CDU_MATRICULA_ORIGEM">
                          </div>
                        </div>
                        <div class="col-md-5">
                          <label for="nome_origem">Nome de Origem</label>
                          <div class="form-group">
                            <input type="text" readonly class="form-control text-center" placeholder="Matricula de origem"
                              id="nome_origem" [value]="name">
                          </div>
                        </div>
                        <div class="col-md-4 mx-auto">
                          <div class="form-group">
                              <label for="meuBem">Meus Bens</label>
                              <div class="form-group">
                                <p>{{cadastro.dS_BPM_DESCRICAO_BEM}}</p>
                              </div>
                              </div>
                      </div>
                        <div class="col-md-4 mx-auto">
                          <div class="form-group">
                              <label for="location">Unidade Operacional</label>
                              
                                  <ng-autocomplete 
                                  id="location"
                                  [data]="localizacao"
                                  [searchKeyword]="keywordUnidade"
                                  (selected)='selectEvent($event)'
                                  [itemTemplate]="itemTemplate"
                                  [notFoundTemplate]="notFoundTemplate"
                                  >                                 
                                </ng-autocomplete>
                                
                                <ng-template #itemTemplate let-item>
                                <a [innerHTML]="item.dS_BPM_UNIDADE">
                                </a>
                                </ng-template>
                                
                                <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                                </ng-template>
                              
                          
                              </div>
                      </div>
                        <div class="col-md-6 mx-auto">
                          <div class="form-group">
                              <label for="matricula_destino">Matricula Destino</label>
                              
                                  <ng-autocomplete 
                                  id="matricula_destino"
                                  [data]="data"
                                  [searchKeyword]="keywordMatriculaDest"
                                  (selected)='selectDest($event)'
                                  [itemTemplate]="itemTemplateMatriculaDest"
                                  [notFoundTemplate]="notFoundTemplateDest">                                 
                                </ng-autocomplete>
                                
                                <ng-template #itemTemplateMatriculaDest let-item>
                                  <a [innerHTML]="item.nome"></a>
                                </ng-template>
                                
                                <ng-template #notFoundTemplateDest let-notFound>
                                <div [innerHTML]="notFound"></div>
                                </ng-template>
                              </div>
                      </div>
                        <div class="col-md-2">
                          <label for="sala">Sala</label>
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Sala"
                              id="sala" formControlName="dS_BPM_SALA_POSTERIOR">
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck1">
                                <label class="custom-control-label" for="customCheck1">Alienação</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12 text-center mx-auto">
                          <button type="button" class="btn btn-outline-dark" (click)="mov_Incon_Alt_Gestor()">Alterar e sanar</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header text-center" id="headingThree">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <strong>Registros</strong>
                  </button>
                </h5>
              </div>
              <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                  <div class="col-md-12">
                    <div class="card-body p-3">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Data da inclusão</th>
                            <th>
                              Autor da evidencia Sanatoria
                            </th>
                            <th>
                              Descrição da evidencia Sanatoria
                            </th>
                            <th>Nome do arquivo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of evidenciaAvulsa">
                            <td>
                              {{ item.dT_BPM_DATA_INCLUSAO_EVIDENCIA | date:'dd/MM/yyyy' }}
                            </td>
                            <td>
                              {{ item.dS_AUTOR_EVIDENCIA }}
                            </td>
                            <td>
                              {{ item.dS_BPM_TEXTO_EVIDENCIA }}
                            </td>
                            <td type="button" class="btn-link" 
                            (click)="upload_abrir(item.cD_BPM_ARQUIVO_PATRIMONIAL)">
                            {{item.dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL}}
                          </td>
                          
                          </tr>
                          <br/>
                          <img> 
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-center" *ngIf="loading">
                <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
            </div>
        </div>
  </div>
  <div *ngIf="!loading" class="modal-footer">
        <div class="mx-auto text-center">
            <button 
            type="button" class="btn btn-danger btn-link" 
            (click)="cancelar()">
            <strong>Fechar a inconsistencia</strong> 
          </button>
        </div>
  </div>
</div>
